import { useState, useEffect, useRef, useCallback, useContext } from "react";
import { Modal, message } from "antd";
import { FaSort, FaSortUp, FaSortDown } from 'react-icons/fa';
import { formatDateIntoDDMMYY, formatPhoneNumberWithoutCntryCode, formatPhoneNumberWithoutCntryCode_WIthoutBracket, isNullUndefine } from "../../control/Constant";
import moment from 'moment';
import Services from "../../network/Services";
import { UserContext } from "../../App";
import InputMask from "../PhoneInputMask";
import OccurrenceModal from "./OccurrenceModal";
import config from '../../config.json';
import { AoAdminBaseUrl } from "../../network/url";


// ─── Styles ───────────────────────────────────────────────────────────────────
const dtHeaderStyle = { color: '#333', fontWeight: 600, fontSize: '13px', background: '#fff', textAlign: 'start', padding: '8px 10px', whiteSpace: 'nowrap', borderColor: '#dee2e6' };
const dtBodyStyle = { color: '#333', fontSize: '13px', textAlign: 'start', fontWeight: 400, padding: '8px 10px', verticalAlign: 'middle', borderColor: '#dee2e6' };
const inputStyle = { width: "100%", padding: "10px 14px", border: "1px solid #333", height: "44px",borderRadius:"2px" };
const labelStyle = { display: "block", marginBottom: "6px" };

// ─── Sub-components ───────────────────────────────────────────────────────────
const Logo = ({ logo }) => <div style={{ textAlign: "center", marginBottom: "14px" }}><h3>{logo}</h3></div>;


// ─── Constants ────────────────────────────────────────────────────────────────
const UI_PAGE_SIZE = 10;
const API_BATCH = 50;
const UI_PER_BATCH = API_BATCH / UI_PAGE_SIZE; // 5

// ─── Main Component ───────────────────────────────────────────────────────────
const AllClients = () => {
    const btnCss = { height: '44px', whiteSpace: 'nowrap', flexShrink: 0, padding: '10px 18px', fontSize: '14px',borderRadius:"2px" };

    const [rows, setRows] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [uiPage, setUiPage] = useState(1);
    const [hasMore, setHasMore] = useState(true);
    const [search, setSearch] = useState("");
    const [debSearch, setDebSearch] = useState("");
    const debTimerRef = useRef(null);
    const [fileList, setFileList] = useState([]);
    const subtenantId = sessionStorage.getItem("subtenantId");
    const loggedUserId = sessionStorage.getItem("loggedUserId");
    const userLoggedInDetail = JSON.parse(sessionStorage.getItem("userLoggedInDetail") || "{}");
    const { setLoader } = useContext(UserContext);
    const [sortKey, setSortKey] = useState("REGISTRATIONDATE");
    const [sortOrder, setSortOrder] = useState("DESC");
    const [isModal, setIsModal] = useState(false);
    const [isModalBulk, setIsModalBulk] = useState(false);
    const [form, setForm] = useState({ firstName: "", lastName: "", email: "", plan: "", countryCode: "(+1) USA", cellNumber: "", sendLink: false, isFreeVersion: false });
    const [plansData, setPlansData] = useState([]);
    const [planOpen, setPlanOpen] = useState(false);
    const [planTableOpen, setTablePlanOpen] = useState(false);
    const [planTableId, setTablePlanId] = useState('');
    const planRef = useRef(null);
    const planRef1 = useRef(null);
    const [countryCodeList, setCountryCodeList] = useState([]);
    const [countryCodeValue, setCountryCodeValue] = useState("+1");
    const [regDisabled, setRegDisabled] = useState(false);
    const [formErrors, setFormErrors] = useState({});
    const [hoveredPlan, setHoveredPlan] = useState(null);
    const reqId = useRef(0);
    const fetchedBatch = useRef(0);
    const hasMoreRef = useRef(true);
    const pendingPageRef = useRef(null);
    const [countrySearch, setCountrySearch] = useState("");
    const [selectedClient,setSelectedClient] = useState(null)
    const [occurenceData,setOccurenceData] = useState(null)
    const [showSentMail,setShowSentMail] = useState(false)
    const [historyModal,setHistorymodal] = useState(false)
    const [uploadResult, setUploadResult] = useState(null);
    const [editedRows, setEditedRows] = useState({});
    const [openId, setOpenId] = useState(null);
    const [activationModal, setActivationModal] = useState(false);
    const [historyData,setHistoryData] = useState()
    const [userResData,setUserResData] = useState()
    const [userActivationData,setUserActivationData] = useState()
    const [workShopData,setWorkShopData] = useState([])
    const isFetchingRef  = useRef(false);
    const pageRef        = useRef(1);
    const observerRef    = useRef(null);
    const lastScrollTop  = useRef(0);
    const [hoveredIndex, setHoveredIndex] = useState(null);

    // ── Bulk upload ──────────────────────────────────────────────────────────────
    const [dragging, setDragging] = useState(false);
    const inputRef = useRef();
    // const handleDrop = (e) => { e.preventDefault(); setDragging(false); setFileList(Array.from(e.dataTransfer.files)); };
    const handleDragOver = (e) => { e.preventDefault(); setDragging(true); };
    const handleDragLeave = () => setDragging(false);
    // const handleFileInput = (e) => setFileList(Array.from(e.target.files));
    const [countryOpen, setCountryOpen] = useState(false);
    const [hoveredCountry, setHoveredCountry] = useState(null);
    const countryRef = useRef(null);


    useEffect(() => {
        fetchWorkShopData()
        const handleClickOutside = (e) => {
            if (planRef.current && !planRef.current.contains(e.target)) setPlanOpen(false);
            if (planRef1.current && !planRef1.current.contains(e.target)) setTablePlanOpen(false);
            if (countryRef.current && !countryRef.current.contains(e.target)) {
                setCountryOpen(false);
                setCountrySearch("");
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    const fetchEmailHistory = async (pageNo) => {
        if (isFetchingRef.current) return; // ✅ guard with ref not state
        if (!hasMore && pageNo > 1) return;
        isFetchingRef.current = true;
        setLoading(true);
        const json = {
            userId: selectedClient?.memberId,
            occurrenceIds: "40,41,42,43",
            pageNumber: pageNo,
            pageSize: 10,
        };


        const _reasult = Services.postCommanApi('getEmailHistory', "POST", json);
        _reasult.then((res) => {
            const newData = Array.isArray(res?.data?.data) ? res?.data?.data : [];
            if (newData.length > 0) {
                setHistoryData((prev) =>
                    pageNo === 1 ? newData : [...(prev || []), ...newData]
                );
                if (newData?.length < 10) setHasMore(false);
            } else {
                if (pageNo === 1) {
                    message.warn("Still no mail sent");
                }
                setHasMore(false);
            }

        }).catch((err) => {

        }).finally(() => {
            setLoading(false);
            isFetchingRef.current = false; // ✅ reset after done
        })
    };

    const lastItemRef = useCallback((node) => {
        if (observerRef.current) observerRef.current.disconnect();
        if (!node) return;

        observerRef.current = new IntersectionObserver((entries) => {
            if (entries[0].isIntersecting && hasMore && !isFetchingRef.current) {
                pageRef.current += 1;
                fetchEmailHistory(pageRef.current);
            }
        }, { threshold: 0.5 }); // ✅ 0.5 instead of 1.0 — fires more reliably

        observerRef.current.observe(node);
    }, [hasMore, fetchEmailHistory]);


    const fetchWorkShopData = async () => {
        fetch(`https://${config?.demo == true ? "uat6." : ""}agingoptions.com/wp-json/ao-workshop/v1/current`)
            .then((res) => res.json())
            .then((data) => {
                setWorkShopData(data)
            })
            .catch((err) => {
                console.error(err);
            });
    }


const validateFiles = (files) => {
    const allowedTypes = [
        'application/vnd.ms-excel',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        'text/csv',
        'application/csv',
    ];
    const allowedExtensions = ['.xls', '.xlsx', '.csv'];

    const invalidFiles = files?.filter(file => {
        const ext = '.' + file.name.split('.').pop().toLowerCase();
        return !allowedTypes.includes(file.type) && !allowedExtensions.includes(ext);
    });

    if (invalidFiles?.length > 0) {
        const names = invalidFiles?.map(f => f.name)?.join(", ");
        message.error(`${names} is not an Excel or CSV file. Only .xls, .xlsx, and .csv files are allowed.`);
        return false;
    }
    return true;
};

const handleDrop = (e) => {
    e.preventDefault();
    setDragging(false);
    const files = Array.from(e.dataTransfer.files);
    if (validateFiles(files)) setFileList(files);
};

const handleFileInput = (e) => {
    const files = Array.from(e.target.files);
    if (validateFiles(files)) {
        setFileList(files);
    } else {
        e.target.value = ""; // reset input so same file can be re-selected after error
    }
};

const sentActivationMail =(data,temp)=>{
    const {templateType,templateContent,subtenantId,emailSubject,templateId} = data
    const {emailId,id} = userResData
    let loginuserid = sessionStorage.getItem('loggedUserId')
    let promise = Services.postSendEmailComm(templateType, emailId,emailSubject,templateId, temp, 1, "tblUsers", id, loginuserid)
    promise.then((response) => {
      message.success("Email Send Successfully")
      setActivationModal(false)
      setLoader(false)
    }).catch((error) => {
      setLoader(false)
    }).finally(() => {
      setLoader(false)
    })
}




    const postbulkfileupload = (files, uploadedby) => {
        const formdata = new FormData();
        files.forEach(file => formdata.append("file", file));
        formdata.append("uploadedBy", uploadedby);
        return Services.fileUploadData(formdata);
    };

    const downloadExcelFile = (response) => {
        const fileDetails = response?.data?.data?.fileDetails;
        if (!fileDetails?.fileDataToByteArray) return;
        const link = document.createElement("a");
        link.href = `data:application/octet-stream;base64,${fileDetails.fileDataToByteArray}`;
        link.download = fileDetails.fileName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    const handleBulkUpload = async () => {
        if (!fileList || fileList?.length === 0) { message.error("Please select a file to upload"); return; }
        setLoading(true); setLoader(true);
        try {
            const response = await postbulkfileupload(fileList, loggedUserId);
            const bulkUsers = response?.data?.data?.bulkUsers || [];
            downloadExcelFile(response);
            setIsModalBulk(false);
            setFileList([]);
            if (inputRef.current) inputRef.current.value = "";
            const total = bulkUsers.length;
            const skipped = bulkUsers.filter(u => u.isUserCreated === false);
            const uploaded = bulkUsers.filter(u => u.isUserCreated === true);
            if (total > 0) {
                const skipped = bulkUsers.filter(u => u.isUserCreated === false);
                const uploaded = bulkUsers.filter(u => u.isUserCreated === true);
                if (skipped.length === 0) {
                    message.success(`All client${total !== 1 ? "s" : ""} uploaded successfully.`);
                    return;
                }
                setUploadResult({
                    total,
                    uploaded: uploaded.length,
                    skipped: skipped.length,
                    skippedRows: skipped.map(u => ({
                        firstName: u["first Name"] || "",
                        lastName: u["last Name"] || "",
                        email: u["email"] || u["userName"] || "",
                        phone: u["phone Number"] || "",
                        _original: { ...u },
                    })),
                });
            } else {
                message.success("File Uploaded Successfully");
            }
        } catch (error) {
            message.error(error?.response?.data?.errors?.file?.[0] || "File upload failed. Please try again.");
        } finally {
            setLoading(false); setLoader(false);
        }
    };

    // ── Fetch plans + country codes on mount ─────────────────────────────────────
    useEffect(() => {
        Services.getcountrycode().then(res => {
            const list = res?.data?.data || [];
            setCountryCodeList(list);
            if (list?.length > 0) { setCountryCodeValue(list[0]?.value || "+1"); setForm(prev => ({ ...prev, countryCode: list[0]?.label || "(+1) USA" })); }
        }).catch(() => { });
        Services.getUserServicePlan()
            .then(res => setPlansData(res?.data?.data || []))
            .catch(() => { });
    }, []);

    // ── fetchBatch ───────────────────────────────────────────────────────────────
    const fetchBatch = useCallback(async (batchNo, searchText, sKey, sOrder, isReset,planID) => {
        const id = ++reqId.current;
        setLoading(true); setLoader(true); setError(null);
        try {
            const body = {
                pageNumber: batchNo,
                rowsOfPage: API_BATCH,
                sortingCol: sKey,
                sortType: sOrder.toUpperCase(),
                searchingCol: "NAME",
                searchingText: searchText || null,
                subtenantId: subtenantId,
                servicePlanId:planID
            };
            const res = await Services.getMembersByParalegalData(body);
            if (id !== reqId.current) return;
            const records = res?.data?.data?.clients || [];
            if (isReset) {
                setRows(records);
            } else {
                setRows(prev => {
                    const map = new Map();
                    [...prev, ...records].forEach(r => map.set(r.loginUserId, r));
                    return [...map?.values()];
                });
            }
            const more = records?.length > 0;
            setHasMore(more);
            hasMoreRef.current = more;
            fetchedBatch.current = batchNo;
            if (pendingPageRef.current !== null) {
                setUiPage(pendingPageRef.current);
                pendingPageRef.current = null;
            }
            setLoading(false);
            setLoader(false);
        } catch (err) {
            if (id !== reqId.current) return;
            // console.error("fetchBatch error:", err);
            setError("Failed to load clients.");
            setHasMore(false); hasMoreRef.current = false;
            setLoading(false);
            setLoader(false);
        } finally {

        }
    }, []);

    // Sirf search pe API call — sort pe nahi (client-side sort hai)
    useEffect(() => {
        fetchedBatch.current = 0;
        hasMoreRef.current = true;
        setHasMore(true);
        setRows([]);
        setUiPage(1);
        fetchBatch(1, debSearch, "REGISTRATIONDATE", "DESC", true,planTableId);
        return () => { if (debTimerRef.current) clearTimeout(debTimerRef.current); };
    }, [debSearch,planTableId]); // only search triggers API

    // Client-side sort on loaded rows — no API call on sort click
    const startIdx = (uiPage - 1) * UI_PAGE_SIZE;
    const sortedRows = [...rows].sort((a, b) => {
        const valA = a[sortKey] ?? "";
        const valB = b[sortKey] ?? "";
        const cmp = String(valA).localeCompare(String(valB), undefined, { sensitivity: 'base' });
        return sortOrder === "DESC" ? cmp : -cmp;
    });
    const pageRows = sortedRows.slice(startIdx, startIdx + UI_PAGE_SIZE);
    const displayEnd = startIdx + pageRows?.length;
    const loadedPages = Math.ceil(rows?.length / UI_PAGE_SIZE) || 0;
    const totalPages = hasMore ? loadedPages + 1 : loadedPages;
    const isLastPage = !hasMore && uiPage >= loadedPages;

    // ── goToPage ──────────────────────────────────────────────────────────────────
    const goToPage = (page, pageNo, isSelected) => {
        const totalPages = Math.ceil(rows?.length / 10);
        if (page < 1) return;
        const neededBatch = Math.ceil(page / UI_PER_BATCH) + 1;
        if (!hasMoreRef.current && page > loadedPages) return;

        if (page > totalPages) {
            pendingPageRef.current = page;
            fetchBatch(neededBatch, debSearch, sortKey, sortOrder, false,planTableId);
        } else {
            setUiPage(page);
        }
    };

    const handleSort = (key) => {
        if (key === sortKey) {
            setSortOrder(prev => prev === "DESC" ? "asc" : "DESC");
        } else {
            setSortKey(key);
            setSortOrder("DESC");
        }
    };

    const sortIcon = (key) => {
        if (sortKey !== key) return <FaSort style={{ color: '#aaa', marginLeft: 4 }} />;
        return sortOrder === 'asc'
            ? <FaSortUp style={{ color: '#720c20', marginLeft: 4 }} />
            : <FaSortDown style={{ color: '#720c20', marginLeft: 4 }} />;
    };

    // ── Pagination page list ──────────────────────────────────────────────────────
    const getPageList = () => {
        const pages = [];
        for (let p = 1; p <= totalPages; p++) {
            if (p === 1 || p === totalPages || (p >= uiPage - 1 && p <= uiPage + 1)) pages.push(p);
        }
        const result = [];
        pages.forEach((p, i) => {
            if (i > 0 && p - pages[i - 1] > 1) result.push('ellipsis-' + p);
            result.push(p);
        });
        return result;
    };

    // ── Row colour helpers ────────────────────────────────────────────────────────
    const today = new Date(); today.setHours(0, 0, 0, 0);
    const safeJson = (v) => { try { return JSON.parse(v || "{}"); } catch { return {}; } };
    const isSameOrAfter = (d) => d && new Date(new Date(d).toDateString()) >= new Date(new Date().toDateString());
    const fmtDate = (v) => moment(v).format('MM-DD-YYYY');

    const isActiveAMA = (subs = []) => subs.some(s => {
        if (Number(s.subscriptionId) !== 1) return false;
        const vd = new Date(s.subscriptionValidityTo); vd.setHours(0, 0, 0, 0);
        return (vd >= today || s.subscriptionValidityTo === null) && (!s.isCancelSubscription || Number(s.subsModeId) === 5);
    });
    const isActiveAMACancelPortal = (subs = []) => subs.some(s =>
        Number(s.subscriptionId) === 1 && Number(s.subsModeId) === 5 &&
        !s.subscriptionValidityFrom && !s.subscriptionValidityTo && s.isCancelSubscription
    );
    const isPayLaterCancel = (subs = []) =>
        Array.isArray(subs) && subs.some(s => Number(s?.subscriptionId) === 1 && Number(s?.documentStatusId) === 2 && s?.isCancelSubscription);

    const getAmaStatus = (subs = []) => {
        if (subs?.length !== 2) return null;
        const s1 = subs?.find(s => s.subscriptionId === 1) || {};
        const s22 = subs?.find(s => s.subscriptionId === 22) || {};
        if (s1.isCancelSubscription && s22.isCancelSubscription) return "BothCancel";
        if (s1.isCancelSubscription && !s22.isCancelSubscription) return "AMACancel";
        if (!s1.isCancelSubscription && s22.isCancelSubscription) return "PortalCancel";
        return null;
    };

    const getBgClass = (c) => {
    
        const subs = c?.userSubscriptionDeatils || [];
        const amt = Number(subs?.[0]?.subscriptionTotalCost) || Number(c?.totalcost) || 0;
        const modeId = Number(c?.subscriptionModeId);
        const shouldAMA = Boolean(c?.subscriptionId === 1 && (c?.amaAuthorizeSubscriptionId || c?.orderId || c?.documentStatusId === 2));
        const isProbate = subs.some(e => e.subscriptionId == 5 && Number(e.subscriptionOrderId) > 0);
        let renewal = c?.validityTo ? fmtDate(c.validityTo)
            : c?.validityFrom ? fmtDate(new Date(new Date(c.validityFrom).setFullYear(new Date(c.validityFrom).getFullYear() + 1)))
                : c?.renewalDate ? fmtDate(c.renewalDate) : null;

        const portalCancelAMAActive = (ss) => { const s1 = ss?.find(s => Number(s.subscriptionId) === 1); const s22 = ss?.find(s => Number(s.subscriptionId) === 22); return Boolean(s22?.isCancelSubscription) && !s1?.isCancelSubscription; };
        // const cancelledAMAorPortal = (ss) => Array.isArray(ss) && (ss.some(s => s.subscriptionId === 1 && s.subsModeId === 4 && s.subscriptionProductName === "AMA (Limited Paid)" && s.isCancelSubscription) || ss.some(s => s.subscriptionId === 22 && s.subsModeId === 5 && s.subscriptionProductName === "Annual Maintenance Agreement" && s.isCancelSubscription));
        const cancelledAMAorPortal = (ss) =>
            Array.isArray(ss) && (
                ss.some(s => Number(s.subscriptionId) === 1 && Number(s.subsModeId) === 4 && s.isCancelSubscription) ||
                ss.some(s => Number(s.subscriptionId) === 22 && Number(s.subsModeId) === 5 && s.isCancelSubscription)
            );

        const limitedAndAnnual = (ss) => ss?.some(s => s.subscriptionId === 1 && s.subsModeId === 4 && s.subscriptionProductName === "AMA (Limited Paid)" && !s.isCancelSubscription) && ss?.some(s => s.subscriptionId === 22 && s.subsModeId === 5 && s.subscriptionProductName === "Annual Maintenance Agreement" && !s.isCancelSubscription);

        const amaStatus = getAmaStatus(subs);
        const redSpecial = subs?.find(s => s.subscriptionId === 1 && [1, 2, 3, 7].includes(s.subsModeId) && s.isCancelSubscription);
        const missedRed = subs?.some(s => { const m = safeJson(s.missedRenewals); return s.subscriptionId === 1 && s.subsModeId === 4 && Number(m?.number) > 0 && m?.paymentSchedule === "Later"; });
        const isBlue = subs.some(s => !s.isCancelSubscription && s.subscriptionId === 1 && [1, 2, 3, 7].includes(s.subsModeId));
        const limitedFuture = modeId === 3 && c.validityTo && isSameOrAfter(c.validityTo) && subs.some(s => +s.subscriptionId === 1 && !s.isCancelSubscription);
        const onlyPortal = subs?.some(s => s.subscriptionId === 22 && s.subsModeId === 5 && safeJson(s.missedRenewals)?.amaTypes === 'Portal');

        if (onlyPortal) return "bg-White-Data-Table";
        if (limitedFuture) return "bg-Blue-Data-Table";
        if (shouldAMA) return "bg-Green-Data-Table";
        if (redSpecial || missedRed || isActiveAMACancelPortal(subs) || isPayLaterCancel(subs)) return "bg-Red-Data-Table";
        if (portalCancelAMAActive(subs)) return "bg-Green-Data-Table";
        if (cancelledAMAorPortal(subs)) { const vd = new Date(subs?.find(s => s.subscriptionId === 1 && s.isCancelSubscription)?.subscriptionValidityTo); return vd >= new Date() ? "bg-Green-Data-Table" : "bg-Red-Data-Table"; }
        if (limitedAndAnnual(subs)) { const lim = subs.find(s => s.subscriptionId === 1 && s.subsModeId === 4 && !s.isCancelSubscription); return lim?.subscriptionValidityTo && new Date(lim.subscriptionValidityTo) < new Date() ? "bg-Red-Data-Table" : "bg-Green-Data-Table"; }
        if (amaStatus === "AMACancel") { const vd = new Date(subs?.find(s => s.subscriptionId === 1 && s.isCancelSubscription)?.subscriptionValidityTo); return vd >= new Date() ? "bg-Green-Data-Table" : "bg-Red-Data-Table"; }
        if (amaStatus === "PortalCancel") return "bg-Green-Data-Table";
        if (amaStatus === "BothCancel") return "bg-Red-Data-Table";
        const freeAMA = !c?.otherAgmtOrderId && c?.amaIsCancelSubscription === null && subs?.[0]?.subscriptionId === 22 && subs[0]?.subscriptionTotalPaid > 0;
        if (subs?.[0]?.isCancelSubscription && subs?.[0]?.subscriptionId === 22) return 'bg-Red-Data-Table';
        if (freeAMA || missedRed) return 'bg-Green-Data-Table';
        if (([1, 2, 3, 4, 5, 7].includes(modeId) || [null, ''].includes(c?.subscriptionModeId)) && c?.amaIsCancelSubscription && !c?.otherAgmtOrderId) { const amaSub = subs?.find(s => s.subscriptionId === 1 && s.isCancelSubscription); if (amaSub?.subscriptionValidityTo) { const vd = new Date(amaSub.subscriptionValidityTo); const t = new Date(); t.setHours(0, 0, 0, 0); return vd < t ? 'bg-Red-Data-Table' : 'bg-Green-Data-Table'; } return 'bg-Red-Data-Table'; }
        if ([1, 2, 3, 4, 5, 7].includes(modeId) && c?.amaIsCancelSubscription && c?.otherAgmtOrderId) return 'bg-Green-Data-Table';
        const vTo = c?.validityTo ? new Date(c.validityTo) : null; const tDay = new Date(); tDay.setHours(0, 0, 0, 0); const vDate = vTo ? new Date(vTo.setHours(0, 0, 0, 0)) : null;
        if ((modeId === 3 || modeId === 1) && vDate) return vDate <= tDay ? 'bg-Red-Data-Table' : 'bg-Blue-Data-Table';
        if (modeId === 4 && vDate) return vDate < tDay ? 'bg-Red-Data-Table' : 'bg-Green-Data-Table';
        if (modeId === 3 && c?.validityTo && new Date(c.validityTo).toDateString() === new Date().toDateString()) return 'bg-Red-Data-Table';
        if ([3, 4].includes(modeId) && c?.validityTo && !isSameOrAfter(c.validityTo)) return 'bg-Red-Data-Table';
        if (c?.isPendingAgreement) return 'bg-White-Data-Table';
        if ([3, 4].includes(modeId)) return amt > 0 ? 'bg-Green-Data-Table' : 'bg-White-Data-Table';
        if (isBlue) return "bg-Blue-Data-Table";
        if ([1, 2, 5, 7].includes(modeId)) return 'bg-Green-Data-Table';
        if (isActiveAMA(subs)) return "bg-Green-Data-Table";
        if (!isNullUndefine(c?.otherAgmtOrderId) && !renewal) return 'bg-White-Data-Table';
        if (isProbate) return 'bg-White-Data-Table';
        if (!renewal && isNullUndefine(c?.otherAgmtOrderId)) return (c?.isFreeVersion === true && (c?.roleId === 10 || c?.roleId !== 9)) ? 'bg-FreeVersion-Data-Table' : 'bg-White-Data-Table';
        if (new Date(renewal) > new Date()) return 'bg-Green-Data-Table';
        if (new Date(renewal) < new Date()) return 'bg-Red-Data-Table';
        if (c?.isFreeVersion === true) return 'bg-FreeVersion-Data-Table';
        return 'bg-White-Data-Table';
    };

    // ── Form ──────────────────────────────────────────────────────────────────────

    // const handleChange = (key) => (e) => {
    //     const val = e.target.type === "checkbox" ? e.target.checked : e.target.value;
    //     setForm(prev => ({ ...prev, [key]: val }));
    //     setFormErrors(prev => ({ ...prev, [key]: undefined }));
    // };
    const handleChange = (key) => (e) => {
    let val = e.target.type === "checkbox" ? e.target.checked : e.target.value;
    if ((key === "firstName" || key === "lastName") && typeof val === "string") {
        val = val.charAt(0).toUpperCase() + val.slice(1);
    }
    setForm(prev => ({ ...prev, [key]: val }));
    setFormErrors(prev => ({ ...prev, [key]: undefined }));
    };

    const handleFreeVersion = (e) => {
        const checked = e.target.checked;
        setForm(prev => ({
            ...prev,
            isFreeVersion: checked,
            plan: checked ? "1" : "",
        }));
        if (checked) {
            setFormErrors(prev => ({ ...prev, plan: undefined }));
        }
    };

    const handleRegister = async () => {

        const errors = {};
        if (!form.firstName.trim()) errors.firstName = "First Name is required";
        if (!form.lastName.trim()) errors.lastName = "Last Name is required";
        if (!form.email.trim()) errors.email = "Email is required";
        else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email)) errors.email = "Invalid email address";
        if (!form.plan) errors.plan = "Please select a plan";
        if (!form.cellNumber.trim()) errors.cellNumber = "Cell number is required";
        else if (form.cellNumber.replace(/\D/g, "")?.length < 10) errors.cellNumber = "Enter a valid Cell Number (min 10 digits)";

        if (Object.keys(errors)?.length > 0) { setFormErrors(errors); return; }
        setFormErrors({});
        if (regDisabled) return;
        setRegDisabled(true); setLoading(true); setLoader(true);
        const payload = {
            subtenantId, signUpPlateform: 6, createUserCredentials: true, createdBy: loggedUserId,
            user: { roleId: 10, firstName: form.firstName.trim(), lastName: form.lastName.trim(), emailAddress: form.email.trim(), userName: form.email.trim(), countryCode: countryCodeValue, mobileNumber: form.cellNumber.trim(), activateUser: false, autoConfirmEmail: false, autoConfirmMobile: false, isFreeVersion: form.isFreeVersion, servicePlanId: form?.plan ?? 1 },
        };
        try {
            const res = await Services.subtenantCreateUserClient(payload);
            const resData = res?.data?.data;
            setUserResData(resData)
            const succeeded = res?.data?.succeeded ?? (resData?.userId ? true : false);
            const errorFlag = res?.data?.errorFlag || resData?.errorFlag;
            const userMode = resData?.userActivationMode;
            if (!res || !succeeded) {
                const apiMessage = res?.data?.messages?.[1] || res?.data?.messages?.[0];
                if (errorFlag === "ROLE_ALREADY_ASSIGNED") message.warning(apiMessage || "Requested role 'Direct Intake Member' is already assigned");
                else if (errorFlag === "EQUIVALENT_ROLE") message.warning(apiMessage || "Cannot assign requested role, equivalent role is already assigned");
                else if (errorFlag === "INVALID_SUBTENANT") message.warning(apiMessage || res?.data?.messages?.[0] || "Invalid subtenant");
                else if (userMode === "ALREADY_REGISTERED") message.warning(apiMessage || "A user with this email already exists");
                else message.error(apiMessage || errorFlag || "Registration failed.");
                setRegDisabled(false); setLoading(false); setLoader(false); return;
            }
            if (form.sendLink) {
                try {
                    const jsonData = {
                        "userRegstrtnId": resData?.id,
                        "userId": resData?.userId,
                        "signUpPlatform": 6,
                        "createdBy": loggedUserId,
                        "clientIPAddress": "::1"
                    }
                    const activationData = Services.getActivationLink(jsonData)
                    activationData.then((response)=>{
                    setUserActivationData(response?.data?.data)
                    setActivationModal(true)
                    return
                    }).catch((err)=>{})
                    // await Services.postSendUserActivationLink(subtenantId, resData?.id, resData?.userId, `${form.firstName.trim()} ${form.lastName.trim()}`, form.email.trim(), resData?.signUpPlatform || 6, loggedUserId, "::1");
                    // message.success("Registered and intake form link sent successfully");
                } catch { message.success("Registered Successfully"); message.warning("Could not send intake form link."); }
            } else { message.success("Registered Successfully"); }
            setForm({ firstName: "", lastName: "", email: "", plan: "", countryCode: form.countryCode, cellNumber: "", sendLink: false, isFreeVersion: false });
            setIsModal(false);
            fetchBatch(1, debSearch, sortKey, sortOrder, true,planTableId);
        } catch (err) {
            const errFlag = err?.response?.data?.errorFlag || err?.data?.errorFlag;
            const userMode = err?.response?.data?.data?.userActivationMode;
            const s = err?.response?.status;
            const apiMessage = err?.response?.data?.messages?.[1] || err?.response?.data?.messages?.[0];
            if (s === 400 && errFlag === "ROLE_ALREADY_ASSIGNED") message.warning(apiMessage || "Requested role 'Direct Intake Member' is already assigned");
            else if (s === 400 && errFlag === "EQUIVALENT_ROLE") message.warning(apiMessage || "Cannot assign requested role, equivalent role is already assigned");
            else if (s === 400 && errFlag === "INVALID_SUBTENANT") message.warning(apiMessage || "Invalid subtenant");
            else if (s === 400 && userMode === "ALREADY_REGISTERED") message.warning(apiMessage || "A user with this email already exists");
            else message.error(apiMessage || errFlag || "Registration failed.");
        } finally { setRegDisabled(false); setLoading(false); setLoader(false); }
    };


    const sendEmailClient = async (data) => {
        setSelectedClient(data)
        const color = getBgClass(data)
        const occurenceId = color === "bg-White-Data-Table" || color === "bg-FreeVersion-Data-Table" ? 42 : color === "bg-Green-Data-Table" ? 40 : color === "bg-Red-Data-Table" ? 41 : color === 'bg-Blue-Data-Table' ? 43 : null
        const jsonData = {
            "occurrenceId": occurenceId,
            "isActive": true,
            "subtenantId": subtenantId,
        }

        setLoader(true)
        const resposneData = Services.postCommediumV2(jsonData)
        resposneData.then((_res)=>{
            setOccurenceData(_res?.data?.data)
            setShowSentMail(true)
             setLoader(false)
        }).catch((err)=>{
             setLoader(false)
         message.error('No communication email has been added. Please contact the admin.');

        })
    }
    // when clicking outside

    const replaceTemplate = (temp,data) => {
        let TemplateContent = temp?.comMediumEmail?.emailTemplateContent || temp?.templateContent;
        const userDetails = JSON.parse(sessionStorage.getItem('userLoggedInDetail'))
        TemplateContent = TemplateContent?.replace("@@CLIENTNAME", selectedClient?.memberName)
        TemplateContent = TemplateContent?.replace("@@COMPANYNAME", temp?.subtenantName)
        TemplateContent = TemplateContent?.replace("@@STAFFNAME", userDetails?.memberName)
        TemplateContent = TemplateContent?.replace("@@CUSTOMERNAME", data?.memberName)
        TemplateContent = TemplateContent?.replaceAll("@@UNIQUELINK", data?.activationURL)
        TemplateContent = TemplateContent?.replace("@@STAFFEMAIL", userDetails?.primaryEmailId)
        TemplateContent = TemplateContent?.replace("@@STAFFPHONE", formatPhoneNumberWithoutCntryCode_WIthoutBracket(userDetails?.primaryPhoneNumber))
        TemplateContent = TemplateContent?.replaceAll("@@SUBTENANTNAME", temp?.subtenantName || userDetails?.subtenantName)
        return TemplateContent;
    }

    const handleAMAShowOccurrence = () => {
        setShowSentMail(false)
        setActivationModal(false)
    }
    const sentTextNMail = async () => {
        const stateObj = JSON.parse(sessionStorage.getItem('stateObj'));
        let emailJson = ''
        if (occurenceData?.[0]?.comMediumEmail) {
            const { emailTemplateType, emailSubject, applicableEmailTempId } = occurenceData?.[0]?.comMediumEmail;
            emailJson = createSentEmailJsonForOccurrene({
                emailType: emailTemplateType,
                emailTo: selectedClient?.primaryEmailAddress,
                emailSubject,
                emailContent: document?.getElementById('emailTemplateEdit')?.innerHTML,
                emailTemplateId: applicableEmailTempId,
                emailMappingTablePKId: loggedUserId,
                emailStatusId: 1,
                emailMappingTablePKId: loggedUserId,
                createdBy: stateObj?.userId,
                userId: selectedClient?.memberId
            })
        }
        setLoader(true)
        const _resultSentEmailtext = await sentMail(emailJson);
        if (_resultSentEmailtext == 'resolve') {
            const messages = `Email sent successfully.`;
              message.success(messages)
              setShowSentMail(false);
              setTimeout(()=>{
              setLoader(false)
              },1000)
        }
    }
    const sentMail = async (emailJson) => {
        return new Promise(async (resolve, reject) => {
            try {
                setLoader(true)
                const _resultEmailSent = Services.postCommanApi('sentEmailWithAsyncCcBc', "POST", emailJson)
                resolve('resolve');
            } catch (error) {
                setLoader(false)
                resolve(error); // Reject the promise in case of an error
            }
        });
    };
    const createSentEmailJsonForOccurrene = ({ emailType, emailTo, emailSubject, emailContent, emailTemplateId, emailMappingTablePKId, emailBcc, emailcc, createdBy, userId }) => {
        return {
            emailType: emailType ?? null,
            emailTo: emailTo ?? null,
            emailSubject: emailSubject ?? null,
            emailContent: emailContent ?? null,
            emailTemplateId: emailTemplateId ?? null,
            emailStatusId: 1,
            emailMappingTable: "tblUsers",
            emailMappingTablePKId: emailMappingTablePKId ?? null,
            emailBcc: emailBcc ?? null,
            emailcc: emailcc ?? null,
            createdBy: createdBy ?? null,
            userId: userId ?? null
        };
    }

const handleClick = () => {
  pageRef.current = 1;
  isFetchingRef.current = false; // ✅ reset on fresh open
  setHistoryData([]);
  setHasMore(true);
  setHistorymodal(true);
  fetchEmailHistory(1);
};

const handleClose = ()=>{
    setUploadResult(null);
    setEditedRows({})
    fetchBatch(1, debSearch, "REGISTRATIONDATE", "DESC", true,planTableId);

}
const workShopRegistration =(data)=>{
    if(workShopData?.workshops?.length < 0) return
    setLoader(true)
    Services.getSubtenantDetail(data?.subtenantId, true)
        .then((res) => {
            const { subtenantName, subtenantLogoUrl } = res.data?.data?.[0] || {};
            /////////////////////////////////////////////////////////////////
            let stateObj = JSON.parse(sessionStorage.getItem('stateObj'));
            let loggedInUserId = sessionStorage.getItem('loggedUserId');
            let roleId =  stateObj?.roleId;
            let tokenKey = `appState=${stateObj?.appState}&userId=${loggedInUserId}&roleId=${roleId}&loggenInId=${stateObj?.loggenInId}&AllClients=${true}`;
            let redirectUrl = `${AoAdminBaseUrl}?token=${window.btoa(tokenKey)}`
             /////////////////////////////////////////////////////////////////
            let Payload = {
                "moConId": 0,
                "moduleConnectionRequest": JSON.stringify({
                    ...data,
                    ["memberRelationship"]: undefined,
                    ["veteran"]: undefined,
                    ["occupation"]: undefined,
                    ["subtenantLogoUrl"]: subtenantLogoUrl,
                    ["subtenantName"]: subtenantName,
                    ["returnUrl"]: redirectUrl,
                }),
                "moduleConnectionResponse": "",
                "isActive": true,
                "requestedFor": null,
                "upsertedBy": ""
            };

            const resposneData = Services.postModuleConnecturl(Payload)
            resposneData.then((_res) => {
                 setLoader(false)
                const workShopUrl = config?.demo ? 'https://uat6.agingoptions.com/registration/?modComId=' : 'https://agingoptions.com/registration/?modComId=';
                window.open(workShopUrl + _res?.data?.[0]?.moConId, '_blank');
            }).catch((err) => {
                 setLoader(false)
             })


        })
        .catch((err) => {
            setLoader(false)
            // konsole.log("ErrorData", err);
        });
}

// const handleAnalyticsClick =()=>{
//    setLoader(true)

//     Services.getSubtenantDetail(subtenantId, true).then((res) => {
//         const { subtenantName, subtenantLogoUrl } = res.data?.data?.[0] || {};
//         let params = `subtenantId=${subtenantId}&subtenantName=${subtenantName}&subtenantLogoUrl=${subtenantLogoUrl}`;
//         let encoded = window.btoa(params);
//         const analyticsUrl = `https://${config?.demo == true ? "uat6." : ""}agingoptions.com/firm-dashboard/?subtenantId=${subtenantId}&expires=${1784200000}&token=${encoded}`
//         setLoader(false)
//         window.open(analyticsUrl, '_blank');
//     }).catch((err) => {
//        setLoader(false)
//     })
// }

    // ── Render ────────────────────────────────────────────────────────────────────
    return (
        <div>


            <style>{`
  .reg-modal-inputs * {
    box-sizing: border-box !important;
    font-family: Open Sans, sans-serif !important;
  }
  .reg-modal-inputs input,
  .reg-modal-inputs select {
    font-size: 13px !important;
    color: #333 !important;
    background: #fff !important;
    border-radius: 2px !important;
    box-shadow: none !important;
    height: 44px !important;
  }
  .reg-modal-inputs input::placeholder {
    color: #333 !important;
    opacity: 1 !important;
    font-size: 13px !important;
  }
  .reg-modal-inputs input[type="checkbox"] {
    height: 20px !important;
    width: 20px !important;
  }
  .reg-modal-inputs input:focus,
  .reg-modal-inputs input:hover,
  .reg-modal-inputs select:focus,
  .reg-modal-inputs select:hover {
    outline: none !important;
    box-shadow: none !important;
    border-color: #333 !important;
    border-radius: 2px !important;
  }
  .reg-modal-inputs h2 {
    font-size: 22px !important;
    font-weight: 700 !important;
    color: #8B1A2B !important;
    text-align: center !important;
    font-family: 'Cormorant Garamond', Georgia, serif !important;
  }
  .reg-modal-inputs h3 {
    font-size: 20px !important;
    font-weight: 600 !important;
    color: #333 !important;
    text-align: center !important;
  }
  .reg-modal-inputs span[style] {
    font-size: 13px !important;
  }
  .reg-modal-inputs button.add-user-btn {
    border-radius: 2px !important;
    font-size: 14px !important;
    font-weight: 700 !important;
  }
    .reg-modal-inputs .ant-input {
    border: none !important;
    box-shadow: none !important;
    outline: none !important;
    border-radius: 0 !important;
    height: 42px !important;
    font-size: 13px !important;
    color: #333 !important;
    background: transparent !important;
    padding: 10px 14px !important;
    width: 100% !important;
}
.reg-modal-inputs .ant-input:hover,
.reg-modal-inputs .ant-input:focus {
    border: none !important;
    box-shadow: none !important;
    outline: none !important;
    border-color: transparent !important;
}
.reg-modal-inputs .ant-input::placeholder {
    color: #333 !important;
    opacity: 1 !important;
    font-size: 13px !important;
}
 td span{
 padding : 0 !important
 }
`}</style>

            <div className="d-flex align-items-center justify-content-between mb-3" style={{ borderBottom: "1px solid #474747" }}>
                <button className="schedule-active me-2 schedule fw-bold border-gray ps-0" style={{ padding: ".5rem", fontSize: '18px !important', fontWeight: 600 }}>Clients</button>
            </div>

            {/* Search + Buttons */}
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px', flexWrap: 'wrap' }}>
                <div style={{ flex: 1, minWidth: '200px', display: 'flex', border: '1px solid #333', height: '44px', alignItems: 'center', borderRadius: "2px" }}>
                    <img style={{ padding: '2px', height: '20px', marginRight: '2px', marginLeft: '4px' }} src="/search icon.png" alt="search" />
                    <input
                        className="form-control newInput searchBox"
                        style={{ border: 'none', outline: 'none', flex: 1, height: '100%' }}
                        type="text" placeholder="Search clients..."
                        value={search}
                        onChange={e => {
                            const val = e.target.value;
                            setSearch(val);
                            if (debTimerRef.current) clearTimeout(debTimerRef.current);
                            debTimerRef.current = setTimeout(() => setDebSearch(val.trim()), 500);
                        }}
                    />
                </div>
                <div style={{ flex: 1, position: 'relative', height: "44px", maxWidth: '200px' }} ref={planRef1}>
                    {/* Trigger button */}
                    <div
                        onClick={() => setTablePlanOpen(prev => !prev)}
                        style={{
                            ...inputStyle,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            cursor: 'pointer',
                            borderColor: formErrors.plan ? 'red' : '#333',
                            userSelect: 'none',
                            background: '#fff',
                        }}>
                        <span style={{ color: planTableId ? '#333' : '#333', fontSize: 13 }}>
                            {planTableId
                                ? (plansData?.find(p => String(p.value) === String(planTableId))?.label || planTableId)
                                : 'Select Plan'}
                        </span>
                        <img className="" style={{ cursor: "pointer" }} src="/icons/keyboard_arrow_downblack.svg" />
                    </div>

                    {/* Dropdown list */}
                    {planTableOpen && (
                        <div style={{
                            position: 'absolute',
                            top: '100%',
                            left: 0,
                            right: 0,
                            background: '#fff',
                            border: '1px solid #333',
                            zIndex: 999,
                            maxHeight: 190,
                            overflowY: 'auto',
                            boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
                            margin: 0,
                            padding: 0,
                        }}>

                            {/* Select Plan reset option */}
                            <div
                                onClick={() => { setTablePlanId() }}
                                style={{
                                    padding: '8px 12px',
                                    fontSize: 13,
                                    cursor: 'pointer',
                                    color: !planTableId ? '#720C20' : '#999',
                                    backgroundColor: !planTableId ? '#F7E4E7' : '#fff',
                                    fontWeight: !planTableId ? 600 : 400,
                                    //   borderLeft: !form.plan ? '3px solid #720C20' : '3px solid transparent',
                                }}>
                                Select Plan
                            </div>

                            {/* Plan options */}

                            {(plansData?.length > 0
                                ? plansData
                                : ["Basic", "Standard", "Premium", "Enterprise"]?.map(o => ({ label: o, value: o }))
                            )?.map((p, i) => {
                                const isSelected = String(planTableId) === String(p.value);
                                const isHovered = hoveredPlan === String(p.value);
                                return (
                                    <div
                                        key={i}
                                        onClick={() => { setTablePlanId(p.value); setTablePlanOpen(false) }}
                                        onMouseEnter={() => setHoveredPlan(String(p.value))}
                                        onMouseLeave={() => setHoveredPlan(null)}
                                        style={{
                                            padding: '8px 12px',
                                            fontSize: 13,
                                            cursor: 'pointer',
                                            borderLeft: isSelected ? '3px solid #720C20' : '3px solid transparent',
                                            color: isSelected ? '#720C20' : '#333',
                                            backgroundColor: isSelected ? '#F7E4E7' : isHovered ? '#F4E9EC' : '#fff',
                                            fontWeight: isSelected ? 600 : 400,
                                        }}
                                    >
                                        {p.label}
                                    </div>
                                );
                            })}
                        </div>
                    )}

                    {/* {formErrors.plan && <span style={{ color: 'red', fontSize: 13, marginTop: 3, display: 'block' }}>{formErrors.plan}</span>} */}
                </div>
                <button className="add-user-btn" style={btnCss} onClick={() => setIsModalBulk(true)}>Import Clients</button>
                <button className="add-user-btn" style={btnCss} onClick={() => setIsModal(true)}>Single Registration</button>
            </div>

            {/* Table */}
            <div style={{ border: '1px solid #dee2e6', marginTop: '12px', display: 'flex', flexDirection: 'column' }}>
                <div style={{ maxHeight: 'calc(100vh - 220px)', overflowY: 'auto' }}>
                    <table className="table table-bordered mb-0 staff-table custom-striped-table" style={{ fontFamily: "Open Sans, sans-serif", fontSize: '13px' }}>
                        <thead style={{ position: 'sticky', top: -1, zIndex: 1, background: '#fff' }}>
                            <tr>
                                <th style={{ ...dtHeaderStyle, cursor: 'pointer' }} onClick={() => handleSort('memberName')}>Name {sortIcon('memberName')}</th>
                                <th style={{ ...dtHeaderStyle, cursor: 'pointer' }} onClick={() => handleSort('primaryEmailAddress')}>Email {sortIcon('primaryEmailAddress')}</th>
                                <th style={{ ...dtHeaderStyle, cursor: 'pointer' }} onClick={() => handleSort('primaryPhoneNumber')}>Phone Number {sortIcon('primaryPhoneNumber')}</th>
                                <th style={dtHeaderStyle}>Service Plan</th>
                                {/* <th style={dtHeaderStyle}>Product</th> */}
                                {/* <th style={dtHeaderStyle}>Expiry Date</th> */}
                                <th style={dtHeaderStyle}>Status</th>
                                {/* <th style={dtHeaderStyle}>WorkShop <img style={{ height: '20px', cursor: "pointer" }} src="/analytics.svg" alt="workshop" onClick={() => handleAnalyticsClick()} /></th> */}
                                <th style={dtHeaderStyle}>WorkShop</th>
                                {/* <th style={dtHeaderStyle}>Payment Status</th> */}
                            </tr>
                        </thead>
                        <tbody>
                            {loading && pageRows?.length === 0 ? (
                                <tr><td colSpan={9} style={{ textAlign: "center", padding: "30px" }}>Loading...</td></tr>
                            ) : error ? (
                                <tr><td colSpan={9} style={{ textAlign: "center", padding: "30px", color: "red" }}>{error}</td></tr>
                            ) : pageRows?.length > 0 ? (
                                pageRows?.map((rec, i) => (
                                    <tr key={rec.loginUserId || i}>
                                        <td className={getBgClass(rec)} style={dtBodyStyle}>
                                            <span className="d-flex justify-content-between">
                                                {rec.memberName || "-"}
                                                <img style={{ padding: '2px', height: '20px', marginRight: '2px', marginLeft: '4px', cursor: "pointer" }} src="/Email2.svg" alt="search" onClick={() => sendEmailClient(rec)} />
                                            </span>

                                        </td>
                                        <td style={dtBodyStyle}>{rec?.primaryEmailAddress || "-"}</td>
                                        <td style={dtBodyStyle}>{formatPhoneNumberWithoutCntryCode(rec?.primaryPhoneNumber) || "-"}</td>
                                        <td style={dtBodyStyle}>{rec?.servicePlanName || "-"}</td>
                                        {/* <td style={dtBodyStyle}>{rec?.productName || "-"}</td> */}
                                        {/* <td style={dtBodyStyle}>{rec?.validityTo ? fmtDate(rec.validityTo) : "-"}</td> */}
                                        {rec?.isUserActive ? (
                                        <td style={dtBodyStyle}>
                                                <span className="activeCls">
                                                    <span style={{ width: '7px', height: '7px', borderRadius: '50%', background: '#15803D', display: 'inline-block', flexShrink: 0 }} />
                                                    Active
                                                </span>
                                            </td>

                                        ) : (

                                            <td style={dtBodyStyle}>
                                                <span className="inActiveCls">
                                                    <span style={{ width: '7px', height: '7px', borderRadius: '50%', background: '#495260', display: 'inline-block', flexShrink: 0 }} />
                                                    Inactive
                                                </span>
                                            </td>)}

                                        {/* <td style={{backgroundColor:rec?.workshopDetails.length > 0 ? "#720C20" : ""}}><img style={{ height: '20px', cursor: "pointer" }} src="/Seminar.svg" alt="workshop" onClick={() => workShopRegistration(rec)} />
                                        </td> */}
                                        <td key={i} style={{ position: "relative", backgroundColor: rec?.workshopDetails?.length > 0 ? "#720C20" : "" }}
                                            onMouseEnter={() => setHoveredIndex(i)} onMouseLeave={() => setHoveredIndex(null)}>
                                            <img
                                                src="/Seminar.svg"
                                                alt="workshop"
                                                style={{ height: "20px", cursor: "pointer" }}
                                                onClick={() => workShopRegistration(rec)}
                                            />

                                            {hoveredIndex === i && rec?.workshopDetails?.length > 0 && (
                                                <div
                                                    style={{
                                                        position: "absolute",
                                                        top: "-30px",
                                                        left: "50%",
                                                        transform: "translateX(-50%)",
                                                        background: "#000",
                                                        color: "#fff",
                                                        padding: "4px 8px",
                                                        borderRadius: "4px",
                                                        whiteSpace: "nowrap",
                                                        zIndex: 999999,
                                                        fontSize: "12px",
                                                    }}
                                                >
                                                    Workshop Registered
                                                </div>
                                            )}
                                        </td>
                                        {/* <td style={dtBodyStyle}>{rec?.intakeStatus || "-"}</td> */}
                                        {/* <td style={dtBodyStyle}>{rec?.totalCost ? `$${rec.totalCost}` : "-"}</td> */}
                                    </tr>
                                ))
                            ) : (
                                <tr><td colSpan={9} style={{ textAlign: "center", padding: "20px", color: "#777" }}>No matching records found.</td></tr>
                            )}
                        </tbody>
                    </table>
                </div>

                {/* Pagination bar */}
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '10px 16px', borderTop: '1px solid #dee2e6', background: '#fff', flexWrap: 'wrap', gap: '8px' }}>
                    <span style={{ fontSize: '13px', color: '#555' }}>
                        Showing {rows?.length === 0 ? 0 : startIdx + 1} to {displayEnd} of {rows?.length}{hasMore ? '+' : ''} entries
                    </span>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                        <button onClick={() => goToPage(uiPage - 1)} disabled={uiPage === 1}
                            style={{ width: 28, height: 28, border: '1px solid #dee2e6', borderRadius: 0, background: '#fff', cursor: uiPage === 1 ? 'not-allowed' : 'pointer', color: '#555' }}>‹</button>

                        {getPageList()?.map(p =>
                            String(p).startsWith('ellipsis')
                                ? <span key={p} style={{ padding: '0 4px', fontSize: 13 }}>...</span>
                                : <button key={p} onClick={() => goToPage(p)}
                                    style={{ width: 28, height: 28, border: '1px solid #dee2e6', borderRadius: 0, background: uiPage === p ? '#720c20' : '#fff', color: uiPage === p ? '#fff' : '#555', cursor: 'pointer', fontSize: 13 }}
                                >{p}</button>
                        )}

                        <button onClick={() => goToPage(uiPage + 1)} disabled={isLastPage}
                            style={{ width: 28, height: 28, border: '1px solid #dee2e6', borderRadius: 0, background: '#fff', cursor: isLastPage ? 'not-allowed' : 'pointer', color: '#555' }}>›</button>
                    </div>
                </div>
            </div>

            {/* Single Registration Modal */}
            {isModal && (
                <Modal visible={isModal} enforceFocus={false} footer={null} closable={false} centered maskClosable={false} width={600} bodyStyle={{ padding: 0, borderRadius: "0" }}>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '14px 16px 12px', borderBottom: '1px solid #bfbfbf' }}>
                        <p style={{ fontSize: 16, fontWeight: 700, color: '#333', margin: 0 }}>Add New Client</p>
                        <span onClick={() => { setIsModal(false); setFormErrors({}); setForm({ firstName: "", lastName: "", email: "", plan: "", countryCode: form.countryCode, cellNumber: "", sendLink: false, isFreeVersion: false }); }}
                            style={{ cursor: 'pointer', fontSize: 24, color: '#555', lineHeight: 1, padding: '2px 6px' }}>×</span>
                    </div>

                    <div className="reg-modal-inputs" style={{ border: '1.5px dashed #720C20', borderRadius: 2, padding: 20, margin: 16 }}>
                        <Logo logo={userLoggedInDetail?.subtenantName} />
                        <h1 style={{ fontFamily: "'Cormorant Garamond', Georgia, serif", fontSize: 22, fontWeight: 700, color: '#333', textAlign: 'center', marginBottom: 24 }}>
                            Client Registration
                        </h1>

                        {/* Row 1 - First Name & Last Name */}
                        <div style={{ display: 'flex', gap: 16, marginBottom: 16 }}>
                            <div style={{ flex: 1 }}>
                                <input
                                    placeholder="Enter First Name"
                                    value={form.firstName}
                                    onChange={handleChange("firstName")}
                                    autoComplete="off"
                                    style={{ ...inputStyle, borderColor: formErrors.firstName ? 'red' : '#333' }}
                                />
                                {formErrors.firstName && <span style={{ color: 'red', fontSize: 13, marginTop: 3, display: 'block' }}>{formErrors.firstName}</span>}
                            </div>
                            <div style={{ flex: 1 }}>
                                <input
                                    placeholder="Enter Last Name"
                                    value={form.lastName}
                                    onChange={handleChange("lastName")}
                                    autoComplete="off"
                                    style={{ ...inputStyle, borderColor: formErrors.lastName ? 'red' : '#333' }}
                                />
                                {formErrors.lastName && <span style={{ color: 'red', fontSize: 13, marginTop: 3, display: 'block' }}>{formErrors.lastName}</span>}
                            </div>
                        </div>

                        {/* Row 2 - Email & Plan */}
                        <div style={{ display: 'flex', gap: 16, marginBottom: 16 }}>
                            <div style={{ flex: 1 }}>
                                <input
                                    placeholder="Enter Email"
                                    value={form.email}
                                    onChange={handleChange("email")}
                                    autoComplete="off"
                                    style={{ ...inputStyle, borderColor: formErrors.email ? 'red' : '#333' }}
                                />
                                {formErrors.email && <span style={{ color: 'red', fontSize: 13, marginTop: 3, display: 'block' }}>{formErrors.email}</span>}
                            </div>

                            <div style={{ flex: 1, position: 'relative' }} ref={planRef}>
                                {/* Trigger button */}
                                <div
                                    onClick={() => setPlanOpen(prev => !prev)}
                                    style={{
                                        ...inputStyle,
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'space-between',
                                        cursor: 'pointer',
                                        borderColor: formErrors.plan ? 'red' : '#333',
                                        userSelect: 'none',
                                        background: '#fff',
                                    }}>
                                    <span style={{ color: form.plan ? '#333' : '#333', fontSize: 13 }}>
                                        {form.plan
                                            ? (plansData?.find(p => String(p.value) === String(form.plan))?.label || form.plan)
                                            : 'Select Plan'}
                                    </span>
                                    <img className="" style={{ cursor: "pointer" }} src="/icons/keyboard_arrow_downblack.svg" />
                                </div>

                                {/* Dropdown list */}
                                {planOpen && (
                                    <div style={{
                                        position: 'absolute',
                                        top: '100%',
                                        left: 0,
                                        right: 0,
                                        background: '#fff',
                                        border: '1px solid #333',
                                        zIndex: 999,
                                        maxHeight: 190,
                                        overflowY: 'auto',
                                        boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
                                        margin: 0,
                                        padding: 0,
                                    }}>

                                        {/* Select Plan reset option */}
                                        <div
                                            onClick={() => { setForm(prev => ({ ...prev, plan: '' })); setFormErrors(prev => ({ ...prev, plan: undefined })); setPlanOpen(false); }}
                                            style={{
                                                padding: '8px 12px',
                                                fontSize: 13,
                                                cursor: 'pointer',
                                                color: !form.plan ? '#720C20' : '#999',
                                                backgroundColor: !form.plan ? '#F7E4E7' : '#fff',
                                                fontWeight: !form.plan ? 600 : 400,
                                                //   borderLeft: !form.plan ? '3px solid #720C20' : '3px solid transparent',
                                            }}>
                                            Select Plan
                                        </div>

                                        {/* Plan options */}

                                        {(plansData?.length > 0
                                            ? plansData
                                            : ["Basic", "Standard", "Premium", "Enterprise"]?.map(o => ({ label: o, value: o }))
                                        )?.map((p, i) => {
                                            const isSelected = String(form.plan) === String(p.value);
                                            const isHovered = hoveredPlan === String(p.value);
                                            const isDisabled = form.isFreeVersion && String(p.value) !== "1";
                                            return (
                                                <div
                                                    key={i}
                                                    onClick={() => { if (isDisabled) return; setForm(prev => ({ ...prev, plan: p.value })); setFormErrors(prev => ({ ...prev, plan: undefined })); setPlanOpen(false); }}
                                                    onMouseEnter={() => !isDisabled && setHoveredPlan(String(p.value))}
                                                    onMouseLeave={() => setHoveredPlan(null)}
                                                    style={{
                                                        padding: '8px 12px',
                                                        fontSize: 13,
                                                        cursor: isDisabled ? 'not-allowed' : 'pointer',
                                                        borderLeft: isSelected ? '3px solid #720C20' : '3px solid transparent',
                                                        color: isDisabled ? '#bbb' : isSelected ? '#720C20' : '#333',
                                                        backgroundColor: isSelected ? '#F7E4E7' : isHovered ? '#F4E9EC' : '#fff',
                                                        fontWeight: isSelected ? 600 : 400,
                                                        opacity: isDisabled ? 0.5 : 1,
                                                    }}
                                                >
                                                    {p.label}
                                                </div>
                                            );
                                        })}
                                    </div>
                                )}

                                {formErrors.plan && <span style={{ color: 'red', fontSize: 13, marginTop: 3, display: 'block' }}>{formErrors.plan}</span>}
                            </div>
                        </div>

                        {/* Row 3 - Country Code & Cell Number */}
                        <div style={{ marginBottom: 13 }}>
                            <div style={{ display: 'flex', gap: 8 }}>

                                {/* Country Code */}
                                <div style={{ position: 'relative', width: 130, flexShrink: 0 }} ref={countryRef}>
                                    {/* Trigger */}
                                    <div
                                        onClick={() => setCountryOpen(prev => !prev)}
                                        style={{
                                            ...inputStyle,
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'space-between',
                                            cursor: 'pointer',
                                            userSelect: 'none',
                                            background: '#fff',
                                            width: 130,
                                        }}>
                                        <span style={{ color: '#333', fontSize: 13 }}>
                                            {(form.countryCode || "").replace(/\(\+[\d-]+\)\s*/, "") || "Country"}
                                        </span>
                                        <img className="" style={{ cursor: "pointer" }} src="/icons/keyboard_arrow_downblack.svg" />
                                    </div>

                                    {/* Dropdown list */}

                                    {countryOpen && (
                                        <div style={{
                                            position: 'absolute',
                                            bottom: '100%',
                                            left: 0,
                                            width: 130, // wider to show full labels
                                            background: '#fff',
                                            border: '1px solid #333',
                                            zIndex: 999,
                                            boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
                                            margin: 0,
                                            padding: 0,
                                        }}>
                                            {/* Search input */}
                                            <div style={{ padding: '6px 8px', borderBottom: '1px solid #eee' }}>
                                                <input
                                                    autoFocus
                                                    placeholder="Search country..."
                                                    value={countrySearch}
                                                    onChange={e => setCountrySearch(e.target.value)}
                                                    onClick={e => e.stopPropagation()}
                                                    style={{
                                                        width: '100%',
                                                        padding: '6px 10px',
                                                        fontSize: 13,
                                                        border: '1px solid #333',
                                                        outline: 'none',
                                                        borderRadius: 0,
                                                        boxSizing: 'border-box',
                                                    }}
                                                />
                                            </div>

                                            {/* Filtered options */}
                                            <div style={{ maxHeight: 160, overflowY: 'auto' }}>
                                                {(countryCodeList?.length > 0
                                                    ? countryCodeList
                                                    : [{ label: "(+1) USA", value: "+1" }, { label: "(+44) UK", value: "+44" }, { label: "(+91) India", value: "+91" }, { label: "(+61) AUS", value: "+61" }]
                                                )
                                                    ?.filter(c => c.label.toLowerCase().includes(countrySearch.toLowerCase()))
                                                    ?.map((c, i) => {
                                                        const isSelected = form.countryCode === c.label;
                                                        const isHovered = hoveredCountry === c.label;
                                                        return (
                                                            <div
                                                                key={i}
                                                                onClick={() => {
                                                                    setCountryCodeValue(c.value);
                                                                    setForm(prev => ({ ...prev, countryCode: c.label,cellNumber: "" }));
                                                                    setCountryOpen(false);
                                                                    setCountrySearch("");
                                                                    setHoveredCountry(null);
                                                                }}
                                                                onMouseEnter={() => setHoveredCountry(c.label)}
                                                                onMouseLeave={() => setHoveredCountry(null)}
                                                                style={{
                                                                    padding: '8px 12px',
                                                                    fontSize: 13,
                                                                    cursor: 'pointer',
                                                                    color: isSelected ? '#720C20' : '#333',
                                                                    backgroundColor: isSelected ? '#F7E4E7' : isHovered ? '#F4E9EC' : '#fff',
                                                                    fontWeight: isSelected ? 600 : 400,
                                                                    whiteSpace: 'nowrap',
                                                                }}
                                                            >
                                                                {c.label}
                                                            </div>
                                                        );
                                                    })}

                                                {/* No results */}
                                                {(countryCodeList?.length > 0 ? countryCodeList : [])?.filter(c =>
                                                    c.label.toLowerCase().includes(countrySearch.toLowerCase())
                                                )?.length === 0 && (
                                                        <div style={{ padding: '10px 12px', fontSize: 13, color: '#999' }}>No results found</div>
                                                    )}
                                            </div>
                                        </div>



                                    )}
                                </div>

                                <div style={{ flex: 1 }}>

                                    <div style={{
                                        border: `1px solid ${formErrors.cellNumber ? 'red' : '#333'}`,
                                        height: '44px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        background: '#fff',
                                        borderRadius: "2px"
                                    }}>
                                        <InputMask
                                            placeholder="Enter Cell Number"
                                            value={form.cellNumber}
                                            onValueChange={(digits) => {
                                                setForm(prev => ({ ...prev, cellNumber: digits }));
                                                setFormErrors(prev => ({ ...prev, cellNumber: undefined }));
                                            }}
                                            disabled={false}
                                        />
                                    </div>
                                    {formErrors.cellNumber && <span style={{ color: 'red', fontSize: 13, marginTop: 3, display: 'block' }}>{formErrors.cellNumber}</span>}
                                </div>

                            </div>
                        </div>

                        {/* Checkbox */}
                        <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 13 }}>
                            <input type="checkbox" checked={form.sendLink} onChange={handleChange("sendLink")} style={{ width: "20px",height:"30px" }} />
                            <span style={{ fontSize: "17px", color: "#333" }}>Send intake form link</span>
                        </div>

                        <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 20 }}>
                            <input type="checkbox" checked={form.isFreeVersion} onChange={handleFreeVersion} style={{ width: "20px" }} />
                            <span style={{ fontSize: "17px", color: "#333" }}>Free version</span>
                        </div>

                        {/* Submit */}
                        <button
                            onClick={handleRegister}
                            disabled={regDisabled}
                            className="add-user-btn"
                            style={{ width: '100%', padding: "10px 18px", background: regDisabled ? '#aaa' : '#8B1A2B', color: '#fff', border: 'none', fontWeight: 700, cursor: regDisabled ? 'not-allowed' : 'pointer', borderRadius: "2px" }}>
                            {form.sendLink ? "Register and Send Intake Form Link" : "Register"}
                        </button>
                    </div>
                </Modal>
            )}

            {/* Bulk Upload Modal */}
            {isModalBulk && (
                <Modal visible={isModalBulk} enforceFocus={false} footer={null} closable={false} centered maskClosable={false} width={600} bodyStyle={{ padding: 0 }}>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '14px 16px 12px', borderBottom: '1px solid #bfbfbf' }}>
                        <p style={{ fontSize: 16, fontWeight: 700, color: '#333', margin: 0 }}>Import Clients</p>
                        {/* <span onClick={() => setIsModalBulk(false)} style={{ cursor: 'pointer', fontSize: 18, color: '#555', lineHeight: 1, padding: '2px 6px' }}>×</span> */}
                        <span onClick={() => { setIsModalBulk(false); setFileList([]); if (inputRef.current) inputRef.current.value = ""; }} style={{ cursor: 'pointer', fontSize: 23, color: '#555', lineHeight: 1, padding: '2px 6px' }}>×</span>
                    </div>
                    <div style={{ border: '1.5px dashed #720C20', borderRadius: 2, padding: 20, margin: 16 }}>
                        <div style={{ padding: "32px 28px 28px" }}>
                            <p style={{ textAlign: "center", fontSize: "16px", fontWeight: "700", color: "#222", marginBottom: "24px", marginTop: 0 }}>Drag and Drop your Files</p>
                            <div onClick={() => inputRef.current.click()} onDrop={handleDrop} onDragOver={handleDragOver} onDragLeave={handleDragLeave}
                                style={{ borderRadius: "0px", background: dragging ? "rgba(139,26,43,0.04)" : "#fafafa", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", cursor: "pointer", minHeight: "180px" }}>
                                <input ref={inputRef} type="file" style={{ display: "none" }} onChange={handleFileInput} />
                                <img src="/upload_file.svg" style={{ width: "10rem" }} />
                                {fileList?.length > 0 ? (
                                    <div style={{ textAlign: "center" }}>
                                        <p style={{ color: "#8B1A2B", fontWeight: "700", margin: "0 0 4px", fontSize: "14px" }}>{fileList.length} file{fileList.length > 1 ? "s" : ""} selected</p>
                                        <p style={{ color: "#333", fontSize: "14px", margin: 0 }}>{fileList?.map(f => f.name).join(", ")}</p>
                                    </div>
                                ) : (
                                    <p style={{ color: "#333", fontSize: "14px", margin: 0, textAlign: "center" }}>Upload CSV Format: <strong>First Name, Last Name, Email, Phone Number</strong></p>
                                )}
                            </div>
                            <div style={{ textAlign: "center", marginTop: "24px" }}>
                                <button onClick={handleBulkUpload} className="add-user-btn"
                                    style={{ padding: "10px 18px", background: "#8B1A2B", color: "#fff", border: "none", fontSize: "15px", fontWeight: "700", cursor: "pointer", height: "44px", borderRadius: "2px" }}
                                    onMouseEnter={e => e.target.style.background = "#6e1522"}
                                    onMouseLeave={e => e.target.style.background = "#8B1A2B"}>
                                    Upload
                                </button>
                            </div>
                        </div>
                    </div>
                </Modal>
            )}
            <OccurrenceModal
                emailObj={replaceTemplate(occurenceData?.[0])}
                commChannelId={occurenceData?.[0]?.commChannelId || null}
                show={showSentMail}
                activationModal={activationModal}
                showHistory={historyModal}
                onHide={setShowSentMail}
                onHideHistory={setHistorymodal}
                closeModal={handleAMAShowOccurrence}
                sentMail={sentTextNMail}
                isParamail={true}
                handleClick={handleClick}
                refrencePage={activationModal == true ? "sentEmail" : "occurence"}
                historyData={historyData}
                setOpenId={setOpenId}
                openId={openId}
                loading={loading}
                selectedClient={selectedClient}
                lastItemRef={lastItemRef}
                sentActivationMail={sentActivationMail}
                userActivationData={userActivationData}
                replaceTemplate={replaceTemplate}
            />

            {uploadResult && (
                <Modal visible={!!uploadResult} footer={null} closable={false} centered maskClosable={false} width={680} bodyStyle={{ padding: 0, borderRadius: 2 }}>
                    <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "14px 18px 12px", borderBottom: "1px solid #dee2e6" }}>
                        <p style={{ fontSize: 15, fontWeight: 700, color: "#333", margin: 0 }}>Upload Summary</p>
                        <span onClick={() => handleClose()} style={{ cursor: "pointer", fontSize: 22, color: "#888", lineHeight: 1, padding: "2px 6px" }}>×</span>
                    </div>

                    <div style={{ padding: "16px 18px 0" }}>
                        <div style={{ display: "grid", gridTemplateColumns: "repeat(3,1fr)", gap: 10, marginBottom: 14 }}>
                            {[
                                { val: uploadResult.uploaded, label: "Uploaded", bg: "#f0faf0", border: "#b7ebc0", color: "#2e7d32", sub: "#4caf50" },
                                { val: uploadResult.skipped, label: "Already existed", bg: "#fff8f0", border: "#ffd59e", color: "#e65100", sub: "#ef6c00" },
                                { val: uploadResult.total, label: "Total in file", bg: "#f5f5f5", border: "#e0e0e0", color: "#333", sub: "#777" },
                            ].map(({ val, label, bg, border, color, sub }) => (
                                <div key={label} style={{ background: bg, border: `1px solid ${border}`, borderRadius: 4, padding: "12px 10px", textAlign: "center" }}>
                                    <div style={{ fontSize: 26, fontWeight: 700, color }}>{val}</div>
                                    <div style={{ fontSize: 12, color: sub, marginTop: 3 }}>{label}</div>
                                </div>
                            ))}
                        </div>

                        <div style={{ background: "#fff8f0", border: "1px solid #ffd59e", borderRadius: 4, padding: "10px 13px", fontSize: 13, color: "#333", marginBottom: 14, lineHeight: 1.5 }}>
                            The uploaded file contains one or more email addresses that are already registered with another firm. You can edit the details below and re-upload, or close to skip.
                        </div>

                        {uploadResult.skippedRows?.length > 0 && <>
                            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 6 }}>
                                <span style={{ fontSize: 13, fontWeight: 600, color: "#555" }}>
                                    Skipped clients <span style={{ fontWeight: 400, color: "#aaa" }}>({uploadResult.skipped})</span>
                                </span>
                                {uploadResult.skippedRows.length > 3 && <span style={{ fontSize: 11, color: "#bbb" }}>scroll to see all</span>}
                            </div>

                            <div style={{ height: uploadResult.skippedRows.length <= 3 ? "auto" : 220, overflowY: uploadResult.skippedRows.length <= 3 ? "visible" : "auto", border: "1px solid #eee", borderRadius: 4 }}>
                                <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 13 }}>
                                    <thead style={{ position: "sticky", top: 0, zIndex: 1 }}>
                                        <tr style={{ background: "#f7f7f7", borderBottom: "1px solid #dee2e6" }}>
                                            {["#", "First Name", "Last Name", "Email", "Phone"].map(h => (
                                                <td key={h} style={{ padding: "8px 10px", color: "#333", fontSize: 12, fontWeight: 600, whiteSpace: "nowrap", textAlign: "left" }}>{h}</td>
                                            ))}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {uploadResult.skippedRows.map((row, i) => {
                                            const edited = editedRows[i] || {};
                                            const cur = { ...row, ...edited };
                                            const isChanged = Object.keys(edited).length > 0;
                                            return (
                                                <tr key={i} style={{ background: isChanged ? "#fffbf0" : i % 2 === 0 ? "#fff" : "#fafafa", borderBottom: "1px solid #f0f0f0" }}>
                                                    <td style={{ padding: "6px 10px", color: "#bbb", fontSize: 12, width: 28 }}>{i + 1}</td>
                                                    {["firstName", "lastName", "email", "phone"].map(field => (
                                                        <td key={field} style={{ padding: "4px 6px" }}>
                                                            <input
                                                                value={cur[field]}
                                                                onChange={e => {
                                                                    const val = e.target.value;
                                                                    const originalVal = row[field] ?? "";
                                                                    setEditedRows(prev => {
                                                                        const rowEdits = { ...(prev[i] || {}), [field]: val };
                                                                        if (val === originalVal) delete rowEdits[field];
                                                                        if (Object.keys(rowEdits).length === 0) {
                                                                            const updated = { ...prev };
                                                                            delete updated[i];
                                                                            return updated;
                                                                        }
                                                                        return { ...prev, [i]: rowEdits };
                                                                    });
                                                                }}
                                                                style={{
                                                                    width: "100%", padding: "5px 8px", fontSize: 12,
                                                                    border: `1px solid ${isChanged && edited[field] !== undefined ? "#720C20" : "#ddd"}`,
                                                                    borderRadius: 2, outline: "none", background: isChanged && edited[field] !== undefined ? "#fffdf5" : "#fff",
                                                                    color: "#333", boxSizing: "border-box"
                                                                }}
                                                            />
                                                        </td>
                                                    ))}
                                                </tr>
                                            );
                                        })}
                                    </tbody>
                                </table>
                            </div>
                        </>}
                    </div>

                    <div style={{ padding: "14px 18px 18px", display: "flex", gap: 10 }}>
                        {Object.keys(editedRows).length > 0 ? (
                            <>
                                <button
                                    onClick={async () => {
                                        const changedUsers = uploadResult.skippedRows.map((row, i) => ({
                                            ...row,
                                            ...(editedRows[i] || {}),
                                        }));
                                        setLoading(true); setLoader(true);
                                        try {
                                            const formdata = new FormData();
                                            const csvHeader = "First Name,Last Name,Email,Phone Number\n";
                                            const csvRows = changedUsers.map(u =>
                                                `${u.firstName || ""},${u.lastName || ""},${u.email || ""},${u.phone || ""}`
                                            ).join("\n");
                                            const blob = new Blob([csvHeader + csvRows], { type: "text/csv" });
                                            formdata.append("file", blob, "retry_clients.csv");
                                            formdata.append("uploadedBy", loggedUserId || "uploadedby");
                                            const response = await Services.fileUploadData(formdata);
                                            const bulkUsers = response?.data?.data?.bulkUsers || [];
                                            downloadExcelFile(response);
                                            const skipped = bulkUsers.filter(u => u.isUserCreated === false);
                                            const uploaded = bulkUsers.filter(u => u.isUserCreated === true);
                                            if (skipped.length === 0) {
                                                message.success(`All ${changedUsers.length} client${changedUsers.length !== 1 ? "s" : ""} uploaded successfully.`);
                                                // setUploadResult(null); setEditedRows({});
                                                handleClose()
                                            } else {
                                                setUploadResult({
                                                    total: bulkUsers.length,
                                                    uploaded: uploaded.length,
                                                    skipped: skipped.length,
                                                    skippedRows: skipped.map(u => ({
                                                        firstName: u["First Name"] || u["first Name"] || "",
                                                        lastName: u["Last Name"] || u["last Name"] || "",
                                                        email: u["Email"] || u["email"] || u["userName"] || "",
                                                        phone: u["Phone Number"] || u["phone Number"] || "",
                                                        _original: { ...u },
                                                    })),
                                                });
                                                setEditedRows({});
                                                message.warning("Some clients still couldn't be uploaded.");
                                            }
                                        } catch (err) {
                                            message.error("Upload failed. Please try again.");
                                        } finally { setLoading(false); setLoader(false); }
                                    }}
                                    className="add-user-btn"
                                    style={{ flex: 1, padding: "11px 18px", background: "#8B1A2B", color: "#fff", border: "none", fontWeight: 700, cursor: "pointer", borderRadius: 2, fontSize: 14 }}
                                >
                                    Upload Changes
                                </button>
                            </>
                        ) : (
                            <button
                                onClick={() => handleClose()}
                                className="add-user-btn"
                                style={{ flex: 1, padding: "11px 18px", background: "#8B1A2B", color: "#fff", border: "none", fontWeight: 700, cursor: "pointer", borderRadius: 2, fontSize: 14 }}
                            >
                                OK, got it
                            </button>
                        )}
                    </div>
                </Modal>
            )}
        </div>
    );
};

export default AllClients;

